import classnames from 'classnames/bind'
import { format } from 'date-fns'
import { Trans, useTranslation } from 'next-i18next'

// Libs
import useLiveTime from '@/hooks/useLiveTime'
import { bigNumberFormater } from '@/methods/getDisplayPrice'
import { useAppSelector } from '@/redux/hooks'
import { useShop } from '@/hooks/useShop'

// Components
import Image from '@/components/common/Image'
import DataItem from './components/DataItem'
import LiveTag from './components/LiveTag'

// Constants

// Types

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type MerchantInfoType = {
  kolHeadshotUrl: string
  kolName: string
  dummyViews: number
  startTime: string
  liveTime: string
  liveCloseTime: string
  endTime: string
  userCount: number
  isFuture: boolean
  isPast: boolean
  liveType: number
  /** 下單數／成交金額只有競標直播間會傳，一般直播間不傳就不渲染這兩格 */
  orderCount?: number
  gmv?: number
  /** 外層覆寫用（競標間滿版時要解掉置中的 1200 上限） */
  className?: string
  /** 房主的 memberInfoId；一般直播間只給主播看自己的店所以不傳，競標間要用房間店家的 id 才查得到商品數 */
  merchantMemberInfoId?: string
}

const MerchantInfo = (props: MerchantInfoType) => {
  const {
    kolHeadshotUrl,
    kolName,
    dummyViews,
    startTime,
    liveTime,
    liveCloseTime,
    endTime = '',
    userCount,
    isFuture,
    isPast,
    liveType,
    orderCount,
    gmv,
    merchantMemberInfoId,
    className,
  } = props

  const { t } = useTranslation()

  const { liveTime: currentLiveTime, isLessThenTenMinutes } = useLiveTime({
    startTime: liveTime,
    endTime: isPast ? liveCloseTime : endTime,
    liveType,
  })
  const loginMemberInfoId = useAppSelector((value) => value.member.memberData.memberInfoId)
  const { totalProduct } = useShop({ memberInfoId: merchantMemberInfoId || loginMemberInfoId })

  const formatStartTime = startTime ? format(new Date(startTime), 'yyyy/MM/dd HH:mm') : ''
  const formatEndTime = endTime ? format(new Date(endTime), 'HH:mm') : ''

  const durationTime = `(${formatStartTime}-${formatEndTime})`

  return (
    <div className={cx('merchant', className)}>
      <div className={cx('merchant-info')}>
        <div className={cx('merchant-info-image')}>
          <Image src={kolHeadshotUrl} width={36} height={36} style={{ objectFit: 'cover' }} alt='kol avatar' />
        </div>
        <div className={cx('merchant-info-content')}>
          <p className={cx('merchant-info-content-name')}>{kolName}</p>
          {!!totalProduct && (
            <div className={cx('merchant-info-content-product')}>
              <Trans
                i18nKey={'Common_Total_Product'}
                components={{
                  span: <span className={cx('merchant-info-content-product-number')} />,
                }}
                values={{ totalProduct }}
              />
            </div>
          )}
        </div>
      </div>

      <div className={cx('merchant-data')}>
        <DataItem
          title={t('LiveRoom_Start_Title')}
          value={isFuture ? '00:00:00' : currentLiveTime}
          additionalValue={durationTime}
          tag={<LiveTag liveType={liveType} isLessThenTenMinutes={isLessThenTenMinutes} />}
          isTime
          isLessThenTenMinutes={isLessThenTenMinutes}
          isFullWidth
          isPast={isPast}
        />
        <DataItem title={t('LiveRoom_Viewed_Title')} value={isFuture ? '--' : dummyViews} />
        <DataItem title={t('LiveRoom_Viewing_Title')} value={isFuture ? '--' : userCount} />
        {orderCount !== undefined && <DataItem title={t('LiveRoom_Order_Title')} value={isFuture ? '--' : orderCount} />}
        {gmv !== undefined && <DataItem title={t('LiveRoom_Gmv_Title')} value={isFuture ? '--' : `$${bigNumberFormater(gmv)}`} />}
      </div>
    </div>
  )
}

export default MerchantInfo
